import { useNavigate } from "react-router-dom";
import { useState } from "react";

import CustomTable from "../../Components/CustomTable";

const HigherEducation = () => {
    const navigate = useNavigate();
    const [educationType, setEducationType] = useState('pendingservices')
    const [educationDesc, setEducationDesc] = useState('')
    const [tableData, setTableData] = useState([
        { name: "Emilia Clarke", village: "દરકાર્યસ", mobileNumber: "+91 3657486250", taluka: "2024", date: "06-01-2025", },
        { name: "Emilia Clarke", village: "દરકાર્યસ", mobileNumber: "+91 3657486250", taluka: "2024", date: "06-01-2025", },
        { name: "Emilia Clarke", village: "દરકાર્યસ", mobileNumber: "+91 3657486250", taluka: "2024", date: "06-01-2025", },
        { name: "Emilia ClaXrke", village: "દરકાર્યસ", mobileNumber: "+91 3657486250", taluka: "2024", date: "06-01-2025", },
        { name: "Emilia ClaXrke", village: "દરકાર્યસ", mobileNumber: "+91 3657486250", taluka: "2024", date: "06-01-2025", },
    ]);

    const [selectedFilters, setSelectedFilters] = useState({
        dateRange: '',
        status: '',
        category: '',
        type: ''
    });

    const handlePageChange = async (page, limit) => {
        console.log(page, limit);
    };
    const columns = [
        { key: "name", label: "User Name" },
        { key: "mobileNumber", label: "Mobile Number" },
        { key: "village", label: "Village" },
        { key: "taluka", label: "Taluka" },
        { key: "date", label: "Date" },
        {
            key: "action",
            label: "Action",
            renderCell: (key, row) => (
                <div className="flex items-center justify-center gap-2">
                    <button className="flex items-center cursor-pointer space-x-2.5" onClick={handleEditHigherEducation}>
                        <svg width="30" height="30" viewBox="0 0 30 30" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <circle cx="15" cy="15" r="15" fill="#048746" />
                            <path fillRule="evenodd" clipRule="evenodd" d="M20.4134 10.6025C20.9084 11.015 20.9753 11.7506 20.5628 12.2456L14.9339 19.0003C14.3849 19.659 13.3888 19.7042 12.7824 19.0978L9.50821 15.8237C9.0526 15.3681 9.0526 14.6294 9.50821 14.1738C9.96382 13.7182 10.7025 13.7182 11.1581 14.1738L13.7548 16.7704L18.7702 10.7518C19.1827 10.2569 19.9184 10.19 20.4134 10.6025Z" fill="white" />
                        </svg>
                    </button>

                    <button className="flex items-center cursor-pointer space-x-2.5">
                        <svg width="30" height="30" viewBox="0 0 30 30" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <circle cx="15" cy="15" r="15" fill="#D21A0E" />
                            <path fillRule="evenodd" clipRule="evenodd" d="M10.0917 10.0917C10.5473 9.6361 11.286 9.6361 11.7416 10.0917L19.9083 18.2584C20.3639 18.714 20.3639 19.4527 19.9083 19.9083C19.4527 20.3639 18.714 20.3639 18.2584 19.9083L10.0917 11.7416C9.6361 11.286 9.6361 10.5473 10.0917 10.0917Z" fill="white" />
                            <path fillRule="evenodd" clipRule="evenodd" d="M19.9083 10.0917C20.3639 10.5473 20.3639 11.286 19.9083 11.7416L11.7416 19.9083C11.286 20.3639 10.5473 20.3639 10.0917 19.9083C9.6361 19.4527 9.6361 18.714 10.0917 18.2584L18.2584 10.0917C18.714 9.6361 19.4527 9.6361 19.9083 10.0917Z" fill="white" />
                        </svg>
                    </button>
                </div>
            ),
        },
    ];

    const handleEditHigherEducation = (event) => {
        event.preventDefault();
        navigate('edit-higher-education-assistance');
    }
    return (
        <>
            <div className="p-7">
                <div className="xl:flex justify-between items-center my-auto">
                    {/* Filter Section */}
                    <div className="lg:flex flex-wrap gap-4 mb-6 order-2">
                        <div className="md:flex items-center gap-4 ml-auto space-y-2.5 md:space-y-0">
                            <div className="relative">
                                <input
                                    type="search"
                                    placeholder="Search"
                                    className="w-full pl-10 py-2 border border-gray_1 rounded-md focus:outline-none shadow-custom_shadow"
                                />
                                <span className="absolute left-3 top-2.5">
                                    <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
                                        <path fillRule="evenodd" clipRule="evenodd" d="M9.125 1C4.63769 1 1 4.63769 1 9.125C1 13.6123 4.63769 17.25 9.125 17.25C13.6123 17.25 17.25 13.6123 17.25 9.125C17.25 4.63769 13.6123 1 9.125 1ZM2.25 9.125C2.25 5.32804 5.32804 2.25 9.125 2.25C12.922 2.25 16 5.32804 16 9.125C16 12.922 12.922 16 9.125 16C5.32804 16 2.25 12.922 2.25 9.125Z" fill="#8897AE" />
                                        <path d="M16.2337 15.3498C15.9896 15.1057 15.5939 15.1057 15.3498 15.3498C15.1057 15.5939 15.1057 15.9896 15.3498 16.2337L18.683 19.567C18.9271 19.8111 19.3228 19.8111 19.5669 19.567C19.811 19.3229 19.811 18.9272 19.5669 18.6831L16.2337 15.3498Z" fill="#8897AE" />
                                    </svg>
                                </span>
                            </div>
                            <div className="flex items-center gap-4">
                                <select
                                    className="px-4 py-2.5 border rounded-md bg-white text-gray_2 focus:outline-none shadow-custom_shadow"
                                    value={selectedFilters.dateRange}
                                    onChange={(e) => setSelectedFilters({ ...selectedFilters, dateRange: e.target.value })}
                                >
                                    <option value="">સભ્યના ગામનું નામ</option>
                                    <option value="yesterday">ગામનું નામ</option>
                                    <option value="last7days">ગામનું નામ</option>
                                    <option value="last30days">ગામનું નામ</option>
                                </select>

                                <button className="w-full btn flex justify-center items-center space-x-1">
                                    <span className="icon-plus text-[20px] font-extrabold"></span>
                                    <span>Clear Filter</span>
                                </button>
                            </div>
                        </div>
                    </div>
                    {/* Service Type Tab Section */}
                    <ul className="flex mb-3 order-1" role="tablist">
                        <li onClick={() => setEducationType('pendingservices')} className="nav-item">
                            <a
                                className={`py-3 px-4 3xl:px-6 flex items-cente ${educationType === 'pendingservices' ? 'text-primary font-semibold border-b-2 border-primary' : 'text-gray_2 font-normal border-b-2 border-[#F2F2F2] hover:text-primary hover:border-primary'}`}
                                data-bs-toggle="tab"
                                id="All"
                                href="#pending"
                                role="tab"
                                aria-selected="true"
                            >
                                Pending Services
                            </a>
                        </li>
                        <li onClick={() => setEducationType('acceptedservices')} className="nav-item">
                            <a
                                className={`py-3 px-4 3xl:px-6 flex items-center ${educationType === 'acceptedservices' ? 'text-primary font-semibold border-b-2 border-primary' : 'text-gray_2 font-normal border-b-2 border-[#F2F2F2] hover:text-primary hover:border-primary'}`}
                                data-bs-toggle="tab"
                                id="Accepted"
                                href="#accepted"
                                role="tab"
                                aria-selected="false"
                            >
                                Accepted Services
                            </a>
                        </li>
                        <li onClick={() => setEducationType('rejectedservices')} className="nav-item">
                            <a
                                className={`py-3 px-4 3xl:px-6 flex items-center ${educationType === 'rejectedservices' ? 'text-primary font-semibold border-b-2 border-primary' : 'text-gray_2 font-normal border-b-2 border-[#F2F2F2] hover:text-primary hover:border-primary'}`}
                                data-bs-toggle="tab"
                                id="Rejected"
                                href="#rejected"
                                role="tab"
                                aria-selected="false"
                            >
                                Rejected Services
                            </a>
                        </li>
                    </ul>
                </div>
                {/* Table Section */}
                <CustomTable
                    columns={columns}
                    data={tableData}
                    isPagination={true}
                    totalRecords={tableData.length}
                    loading={false}
                    handlePageChange={handlePageChange}
                />
            </div>
        </>
    )
}
export default HigherEducation;
